// Texty detailu značky — slovenské dvojče locale/cs/brandDetail.js.
export default {
  stockLabel: (n) => n + ' produktov skladom',
  chipService: 'Servis a náhradné diely',
  chipWarranty: 'Záruka 24 mesiacov',
  serviceEyebrow: 'Servis značky',
  serviceTitlePre: 'Diely ',
  serviceTitlePost: ' skladom',
  serviceText: 'Batérie, nabíjačky aj bežné náhradné diely riešime na predajni v Bíline.',
  serviceCta: 'Servis náradia',
};
